import { configureStore } from '@reduxjs/toolkit';
import surveyReducer from './surveySlice';
import surveyResponsesReducer from './surveyResponsesSlice';

export const store = configureStore({
  reducer: {
    survey: surveyReducer,
    surveyResponses: surveyResponsesReducer,
  },
});